import { HorizontalSafeAreaContainer } from '../../../components';
import { AddGiftCardScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <HorizontalSafeAreaContainer>
      <AddGiftCardScreen />
    </HorizontalSafeAreaContainer>
  );
}
